import ChevronIcon from '@repo/ui/src/components/Icons/ChevronIcon';
import { StateSetterFunction } from '@repo/ui/src/types/helpers';
import { classNames } from '@repo/ui/src/utils/classNames';

interface Props {
  label: string;
  toggle: StateSetterFunction<boolean>;
  isOpen: boolean;
  hideOnDesktop?: boolean;
  className?: string;
  account?: boolean;
}

const MobileNavigationToggle = ({
  label,
  toggle,
  isOpen,
  hideOnDesktop = false,
  className,
  account,
}: Props) => {
  return (
    <div className={className}>
      <div className={classNames(account ? 'md:tw-hidden' : 'sm:tw-hidden')}>
        <label className="tw-group peer-focus-visible:tw-border-black tw-grid tw-grid-flow-col tw-justify-between tw-items-center">
          <h4
            data-testid="mobile-nav-header"
            className={classNames(account ? 'tra-text-web-body-xl' : 'tra-text-web-sub-2')}
          >
            {label}
          </h4>
          <input
            className="tw-peer tw-absolute tw-h-0 tw-w-0 tw-cursor-pointer"
            aria-label={`${isOpen ? 'Close' : 'Open'} Navigation Menu`}
            type="checkbox"
            checked={isOpen}
            onChange={() => toggle(!isOpen)}
          />
          <span className="tw-w-6 tw-h-6 tw-flex tw-items-center tw-outline-offset-2 tw-outline-brand-300 tw-outline-2 peer-focus-visible:tw-outline">
            <ChevronIcon
              direction={isOpen ? 'up' : 'down'}
              className={classNames(isOpen ? 'tw-text-brand-300' : 'tw-text-neutral-300')}
            />
          </span>
        </label>
      </div>

      {!hideOnDesktop && (
        <h4 className="tw-hidden tra-text-web-sub-2 tw-mb-2 tw-justify-between tw-items-center sm:tw-block">
          {label}
        </h4>
      )}
    </div>
  );
};

export default MobileNavigationToggle;
